<template>
  <div class="text-center text-h2 font-weight-medium">
    <span v-if="api.isLoading">-</span>  
 <span v-else>{{ data }}</span>   
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: ["path","server"],
  computed: mapState({
    school: (state) => state.school.data,
  }),
  data: () => ({
    //BOC:[api]
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    data: [],
    id: null,
    item: null,
  }),
  created() {
    //BOC:[api]
    this.api.method = "get";

    this.api.callbackReset = () => {
      this.api.isLoading = true;
      this.api.isError = false;
    };
    this.api.callbackError = (e) => {
      this.api.isLoading = false;
      this.api.isError = true;
      this.api.error = e;
    };
    this.api.callbackSuccess = (resp) => {
      this.api.isLoading = false;
      this.data = resp;
      this.$emit('loadingCard')
    };
    //EOC
  },

  methods: {
    fetch() {
 
      this.api.url = `${this.$api.servers[this.server]}/api/v1/en/moderator/${this.path}/count`
      this.$api.fetch(this.api);
    },
  },
  beforeMount() {
    this.fetch();
  },
};
</script>
